import { render, staticRenderFns } from "./LessonFolderControls.vue?vue&type=template&id=48e2904a"
import script from "./LessonFolderControls.vue?vue&type=script&lang=js"
export * from "./LessonFolderControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports